module.exports = __webpack_public_path__ + "static/media/flatbed.cbe1e104.svg";